import ButtonSmallMixin from './mixins/button-small-mixin.js';
import ButtonOutlinedMixin from './mixins/button-outlined-mixin.js';
import TpButton from './tp-button.js';

class TpButtonOutlinedSmall extends
  ButtonSmallMixin(
  ButtonOutlinedMixin(
    TpButton
  )) {}

export default TpButtonOutlinedSmall;


